export default __webpack_public_path__ + "static/media/button_shape_rectangle.3ce16bfa.png";